export const navigate = (href: string): void => {
    window.location.href = href;
};
